// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Common - Start **/
.BannerCaption-noPadding-iLR2M {
    padding: 0px;
}
.BannerCaption-noMargin-i23iq {
    margin: 0px;
}
/** Common - End **/
/** Banner caption - Start **/
.BannerCaption-bannerCaptionContainer-YcORZ {
    position: relative;
}
.BannerCaption-bannerCaptionText-wN0Sy {
    font-size: 60px;
    line-height: 66px;
    padding-top: 8px;
    padding-bottom: 8px;
    margin: 0px;
    font-weight: 600;
    text-align: center;
}
.BannerCaption-bannerCaptionHighlight-G1obz {
    font-weight: 700;
    color: var(--primary-bg);
}
@media screen and (max-width: 1200px) {
    .BannerCaption-bannerCaptionText-wN0Sy {
        padding-top: 110px;
    }
}
@media screen and (max-width: 767px) {
    .BannerCaption-bannerCaptionText-wN0Sy {
        font-size: 25px;
        line-height: 30px;
    }
}
/** Banner caption - End **/`, "",{"version":3,"sources":["webpack://./src/components/Home/BannerCaption/BannerCaption.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,YAAY;AAChB;AAEA;IACI,WAAW;AACf;AAEA,mBAAmB;AACnB,6BAA6B;AAC7B;IACI,kBAAkB;AACtB;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;AAEA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;AAEA,2BAA2B","sourcesContent":["/** Common - Start **/\n.noPadding {\n    padding: 0px;\n}\n\n.noMargin {\n    margin: 0px;\n}\n\n/** Common - End **/\n/** Banner caption - Start **/\n.bannerCaptionContainer {\n    position: relative;\n}\n\n.bannerCaptionText {\n    font-size: 60px;\n    line-height: 66px;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    margin: 0px;\n    font-weight: 600;\n    text-align: center;\n}\n\n.bannerCaptionHighlight {\n    font-weight: 700;\n    color: var(--primary-bg);\n}\n\n@media screen and (max-width: 1200px) {\n    .bannerCaptionText {\n        padding-top: 110px;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .bannerCaptionText {\n        font-size: 25px;\n        line-height: 30px;\n    }\n}\n\n/** Banner caption - End **/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noPadding": `BannerCaption-noPadding-iLR2M`,
	"noMargin": `BannerCaption-noMargin-i23iq`,
	"bannerCaptionContainer": `BannerCaption-bannerCaptionContainer-YcORZ`,
	"bannerCaptionText": `BannerCaption-bannerCaptionText-wN0Sy`,
	"bannerCaptionHighlight": `BannerCaption-bannerCaptionHighlight-G1obz`
};
module.exports = ___CSS_LOADER_EXPORT___;
